import { toQueryString } from "../toQueryString";

const path = (path: any, params: any = {}) =>
  `${path}?${toQueryString(params)}`;

export const pushNotifications = {
  list: ({ params = {} }: { params?: object } = {}) =>
    path("/internal_api/push_notification_broadcasts", params),
  create: ({ params = {} }: { params?: object } = {}) =>
    path("/internal_api/push_notification_broadcasts", params),
  show: ({ id, params = {} }: { id: number; params?: object }) =>
    path(`/internal_api/push_notification_broadcasts/${id}`, params),
  update: ({ id, params = {} }: { id: number; params?: object }) =>
    path(`/internal_api/push_notification_broadcasts/${id}`, params),
  send_broadcast: ({ id }: { id: number }) =>
    path(`/internal_api/push_notification_broadcasts/${id}/send_broadcast`),
  duplicate: ({ id }: { id: number }) =>
    path(`/internal_api/push_notification_broadcasts/${id}/duplicate`),
  archive: ({ id }: { id: number }) =>
    path(`/internal_api/push_notification_broadcasts/${id}/archive`),
  deleteBroadcast: ({ id }: { id: number }) =>
    path(`/internal_api/push_notification_broadcasts/${id}`),
  cancelSchedule: ({ id }: { id: number }) =>
    path(`/internal_api/push_notification_broadcasts/${id}/cancel_schedule`),
  sendTestNotification: ({
    id,
    community_member_id,
  }: {
    id: number;
    community_member_id: number;
  }) =>
    path(
      `/internal_api/push_notification_broadcasts/${id}/send_test_notification`,
      { community_member_id },
    ),
  report: ({ id }: { id: number }) =>
    path(`/internal_api/push_notification_broadcasts/${id}/analytics_report`),
  recipients: ({ id, params = {} }: { id: number; params?: object }) =>
    path(`/internal_api/push_notification_broadcasts/${id}/recipients`, params),
};
